<div class="personal-details">
  <div>
    <div>{{ 'label.Gender' | translate }}</div>
    <div [hidden]="field?.genderId?.isInEditMode">
      {{
        (Gender[jobseeker?.genderId]
          ? 'label.' + Gender[jobseeker?.genderId]
          : ''
        ) | translate
      }}
      <button
        [hidden]="field?.genderId?.hasValue"
        class="fa fa-plus-circle btn btn-link"
        (click)="onGenderEditClick()"
        [disabled]="isInEditMode"
      ></button>
      <button
        [hidden]="!field?.genderId?.hasValue"
        class="fa fa-pencil btn btn-link"
        (click)="onGenderEditClick()"
        [disabled]="isInEditMode"
      ></button>
    </div>
    <div [hidden]="!field?.genderId?.isInEditMode">
      <div>
        <select
          [ngModel]="jobseeker && jobseeker.genderId"
          (ngModelChange)="jobseeker && (jobseeker.genderId = $event)"
        >
          <option
            *ngFor="let item of genderList"
            [value]="item.value"
            [selected]="item.value == jobseeker?.genderId"
          >
            {{ item.text }}
          </option>
        </select>
        <!--<cd-field-state data-name='Gender'></cd-field-state>-->
      </div>
      <div>
        <button class="btn btn-default" (click)="onGenderSaveClick()">
          {{ 'label.Save' | translate }}
        </button>
        <button class="btn btn-default" (click)="onGenderEditCancelClick()">
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div>
    <div>{{ 'label.DateOfBirth' | translate }}</div>
    <div [hidden]="field?.birthDate?.isInEditMode">
      {{ jobseeker?.birthDate | date : dateFormat }}
      <button
        [hidden]="field?.birthDate?.hasValue"
        class="fa fa-plus-circle btn btn-link"
        (click)="onBirthDateEditClick()"
        [disabled]="isInEditMode"
      ></button>
      <button
        [hidden]="!field?.birthDate?.hasValue"
        class="fa fa-pencil btn btn-link"
        (click)="onBirthDateEditClick()"
        [disabled]="isInEditMode"
      ></button>
    </div>
    <div [hidden]="!field?.birthDate?.isInEditMode">
      <div>
        <select
          [ngModel]="jobseeker && jobseeker.birthDay"
          (ngModelChange)="
            jobseeker &&
              ((jobseeker.birthDay = $event) || true) &&
              onBirthDateChange()
          "
        >
          <!--<option ng-if="isDateOfBirthEmpty" value="" disabled selected>@Resources.Label.Day</option>-->
          <option
            *ngFor="let item of dayList"
            [value]="item"
            [selected]="item == jobseeker?.birthDay"
          >
            {{ item }}
          </option>
        </select>
        <!--<hr-field-state-marker [field]="field?.birthMonth"></hr-field-state-marker>-->
        <select
          [ngModel]="jobseeker && jobseeker.birthMonth"
          (ngModelChange)="
            jobseeker &&
              ((jobseeker.birthMonth = $event) || true) &&
              onBirthDateChange()
          "
        >
          <!--<option ng-if="isDateOfBirthEmpty" value="" disabled selected>@Resources.Label.Month</option>-->
          <option
            *ngFor="let item of monthList"
            [value]="item.value"
            [selected]="item.value == jobseeker?.birthMonth"
          >
            {{ item.text }}
          </option>
        </select>
        <!--<hr-field-state-marker [field]="field?.birthYear"></hr-field-state-marker>-->
        <select
          [ngModel]="jobseeker && jobseeker.birthYear"
          (ngModelChange)="
            jobseeker &&
              ((jobseeker.birthYear = $event) || true) &&
              onBirthDateChange()
          "
        >
          <!--<option ng-if="isDateOfBirthEmpty" value="" disabled selected>@Resources.Label.Year</option>-->
          <option
            *ngFor="let item of yearList"
            [value]="item.value"
            [selected]="item.value == jobseeker?.birthYear"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <div>
        <button class="btn btn-default" (click)="onBirthDateSaveClick()">
          {{ 'label.Save' | translate }}
        </button>
        <button class="btn btn-default" (click)="onBirthDateEditCancelClick()">
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
      <br />
      <div>
        <hr-field-state-marker
          [field]="field?.birthDay"
        ></hr-field-state-marker>
      </div>
      <div>
        <hr-field-state-marker
          [field]="field?.birthMonth"
        ></hr-field-state-marker>
      </div>
      <div>
        <hr-field-state-marker
          [field]="field?.birthYear"
        ></hr-field-state-marker>
      </div>
    </div>
  </div>
  <div *ngIf="jobseeker && jobseeker.providerWebsiteId == 1">
    <!--TODO: remove-->
    <div>{{ 'label.City' | translate }}</div>
    <div [hidden]="field?.city?.isInEditMode">
      <!-- {{jobseeker?.cityName}} -->
      <span class="locality__text">
        <span
          *ngFor="
            let location of jobseeker?.jobseekerExtendedLocations;
            let last = last
          "
        >
          {{ location }}{{ last ? '' : ', ' }}
        </span>
      </span>

      <button
        [hidden]="field?.city?.hasValue"
        class="fa fa-plus-circle btn btn-link"
        (click)="onCityEditClick()"
        [disabled]="isInEditMode"
      ></button>
      <button
        [hidden]="!field?.city?.hasValue"
        class="fa fa-pencil btn btn-link"
        (click)="onCityEditClick()"
        [disabled]="isInEditMode"
      ></button>
    </div>
    <div [hidden]="!field?.city?.isInEditMode">
      <div>
        <!-- <select [(ngModel)]="jobseeker && jobseeker.cityId">
            <option  *ngFor="let item of localities" [value]="item.value" [selected]="item.value==(jobseeker?.cityId)">{{item.text}}</option>
          </select> -->
        <hr-location-picker
          [ngModel]="jobseeker && jobseeker.extendedLocationPath"
          (ngModelChange)="
            jobseeker && (jobseeker.extendedLocationPath = $event)
          "
          [formControl]="extendedLocationPath"
          class="form-item__label locality__value"
          [locationLevelCount]="locationLevelCount"
          [firstLevelParentLocationId]="locationFirstLevelId"
          [requiredLevelCount]="jobseekerLocationRequiredLevelCount"
          [lastHiddenLevelCount]="jobseekerLocationLastHiddenLevelCount"
        >
        </hr-location-picker>
      </div>
      <div>
        <button
          [disabled]="!extendedLocationPath.valid"
          class="btn btn-default"
          (click)="onCitySaveClick()"
        >
          {{ 'label.Save' | translate }}
        </button>
        <button class="btn btn-default" (click)="onCityEditCancelClick()">
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div>
    <div>{{ 'label.Address' | translate }}</div>
    <div [hidden]="field?.address?.isInEditMode">
      <!--@if (Model.IsAddressPending)
            {
            <span class="fa fa-exclamation-circle in-moderation" title="@Resources.Message.IsInModeration"></span>
        }-->
      {{ jobseeker?.address }}
      <button
        [hidden]="field?.address?.hasValue"
        class="fa fa-plus-circle btn btn-link"
        (click)="onAddressEditClick()"
        [disabled]="isInEditMode"
      ></button>
      <button
        [hidden]="!field?.address?.hasValue"
        class="fa fa-pencil btn btn-link"
        (click)="onAddressEditClick()"
        [disabled]="isInEditMode"
      ></button>
    </div>
    <div [hidden]="!field?.address?.isInEditMode">
      <div>
        <input
          type="text"
          maxlength="50"
          minlength="3"
          [ngModel]="jobseeker && jobseeker.address"
          (ngModelChange)="jobseeker && (jobseeker.address = $event)"
        />
        <hr-field-state-marker [field]="field?.address"></hr-field-state-marker>
      </div>
      <div>
        <button class="btn btn-default" (click)="onAddressSaveClick()">
          {{ 'label.Save' | translate }}
        </button>
        <button class="btn btn-default" (click)="onAddressEditCancelClick()">
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div>
    <div>{{ 'label.DrivingLicence' | translate }}</div>
    <div [hidden]="field?.drivingLicenses?.isInEditMode">
      <span *ngFor="let item of jobseeker?.drivingLicenses">
        {{ item.name }}
        <span
          *ngIf="
            jobseeker?.drivingLicenses?.indexOf(item) !=
            jobseeker?.drivingLicenses?.length - 1
          "
          >,</span
        ></span
      >
      <button
        [hidden]="field?.drivingLicenses?.hasValue"
        class="fa fa-plus-circle btn btn-link"
        (click)="onDrivingLicenseEditClick()"
        [disabled]="isInEditMode"
      ></button>
      <button
        [hidden]="!field?.drivingLicenses?.hasValue"
        class="fa fa-pencil btn btn-link"
        (click)="onDrivingLicenseEditClick()"
        [disabled]="isInEditMode"
      ></button>
    </div>
    <div
      [hidden]="!field?.drivingLicenses?.isInEditMode"
      class="multi-select-dropdown"
    >
      <ul>
        <li *ngFor="let item of jobseeker?.drivingLicenses">
          {{ item.name
          }}<button
            class="remove"
            (click)="onDrivingLicenseOptionRemoveClick(item)"
          >
            x
          </button>
        </li>
      </ul>
      <div>
        <select
          [hidden]="isAllDrivingLicensesSelected"
          [(ngModel)]="drivingLicense"
          (ngModelChange)="onDrivingLicenseChange()"
        >
          <option *ngFor="let item of drivingLicensesInput" [ngValue]="item">
            {{ item.text }}
          </option>
        </select>
        <!--<cd-field-state data-name='DrivingLicenses'></cd-field-state>-->
      </div>
      <div>
        <button class="btn btn-default" (click)="onDrivingLicensesSaveClick()">
          {{ 'label.Save' | translate }}
        </button>
        <button
          class="btn btn-default"
          (click)="onDrivingLicenseEditCancelClick()"
        >
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<div id="photo">
  <div *ngIf="jobseeker?.hasPhoto">
    <img alt="Photo" height="170px" src="{{ jobseeker?.photoHref }}" /><br />
    <button
      class="fa btn btn-default"
      type="button"
      (click)="onPhotoDelete()"
      style="margin-top: 1em"
    >
      {{ 'label.Delete' | translate }}
    </button>
  </div>
  <p *ngIf="!jobseeker?.hasPhoto" class="placeholder">
    <span class="no-photo-text">{{
      'label.NoPhotoAvailableYet' | translate
    }}</span>
  </p>
</div>
